<div class="container h-100">
  <h5>Ihr Behandlungsbeginn</h5>
  <p>
    Bitte erfassen Sie nun das Behandlungsdatum, das ist der Tag an dem Sie in
    der Arztpraxis behandelt werden.
  </p>
  <div class="row row-cols-1">
    <div class="col">
      <form (ngSubmit)="checkReady()" class="p-3">
        <div class="input-group mt-3">
          <label class="small w-100" title="Ihr Geburtstag; erforderlich">
            Ihr Behandlungsbeginn*
          </label>
          <input
            #tnzDp="ngbDatepicker"
            [minDate]="{ year: 1900, month: 1, day: 1 }"
            aria-label="Teilnahmezeitraum"
            class="form-control"
            [formControl]="tnzBeginn"
            ngbDatepicker
            placeholder="TT.MM.JJJJ"
            tabindex="5"
          />
          <span
            (click)="tnzDp.toggle()"
            class="btn btn-outline-info"
          >
              <fa-icon [icon]="calendarIcon"></fa-icon>
            </span>
        </div>
        <san-form-input-error
          [visible]="
            !tnzBeginn.pristine && tnzBeginn.errors && tnzBeginn.errors.required
          "
          message="Bitte geben Sie Ihren Behandlungsbeginn an"
        ></san-form-input-error>
        <san-form-input-error
          [visible]="
            !tnzBeginn.pristine && tnzBeginn.errors && tnzBeginn.errors.badTime
          "
          message="Das gewählte Behandlungsdatum liegt vor dem Beginn {{
            tnzBeginn.errors?.badTime
          }}.
          Bitte prüfen Sie das ausgewählte Behandlungsdatum."
        ></san-form-input-error>
      </form>
    </div>
    <div class="row mt-1">
      <div class="col text-center">
        <button (click)="zurueck.emit()" class="btn btn-primary m-lg-5">
          Zurück
        </button>
      </div>
      <div class="col text-center">
        <button (click)="checkReady()" class="btn btn-primary m-lg-5">
          Weiter
        </button>
      </div>
    </div>
  </div>
</div>
